export default __webpack_public_path__ + "static/media/delete-forever.dcbb0ed3.svg";